import { createFileRoute } from "@tanstack/react-router"

import { EmailNotificationFiltersSchema } from "@optimist/schemas"
import { requirePermissionRouteAccess } from "@/features/authz/require-permission-route-access"
import { NotificationsLogPage } from "@/features/notifications/components/notifications-log-page"

export const Route = createFileRoute("/dashboard/settings/notifications")({
	component: NotificationsLogPage,
	validateSearch: (search) => EmailNotificationFiltersSchema.parse(search),
	beforeLoad: async ({ context }) => {
		await requirePermissionRouteAccess(context.queryClient, "orders.read")
		await requirePermissionRouteAccess(context.queryClient, "patients.read.phi")
	},
})
